import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrudService } from '../../shared/services/crud.service';
import { EmailAddress } from './email-template.type';

@Injectable({
    providedIn: 'root'
})
export class EmailAddressService extends CrudService<EmailAddress> {

    constructor(protected http: HttpClient) {
        super(http, 'emailAddress');
    }
}
